import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45febb5e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=45febb5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45febb5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\mam\\home\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45febb5e')) {
      api.createRecord('45febb5e', component.options)
    } else {
      api.reload('45febb5e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=45febb5e&scoped=true", function () {
      api.rerender('45febb5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accessoriesSearch/index.vue"
export default component.exports